import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 mb-20" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "card-title fw-black mb-20" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "col-12 col-md-4"
}
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "col-12 col-md-4"
}
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 2,
  class: "col-12 col-md-4"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.formColis.code), 1)
          ])
        ]),
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.row.invoiced != 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.auth.can('PARCELS') && _ctx.auth.can('EDIT_FEES_PARCELS'))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.auth.can('PARCELS') && _ctx.auth.can('EDIT_FEES_PARCELS'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _cache[4] || (_cache[4] = _createElementVNode("label", { for: "fl" }, "Frais de livraison *", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  style: {"color":"#f14d12"},
                                  id: "fl",
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formColis.delivered_fees) = $event)),
                                  disabled: 
                        _ctx.row.invoiced == 1 ||
                        (_ctx.row.status == 'DELIVERED' &&
                          (_ctx.row.situation == 'Facturé' || _ctx.row.invoiced == 1))
                      
                                }, null, 8, _hoisted_9), [
                                  [_vModelText, _ctx.formColis.delivered_fees]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.auth.can('PARCELS') && _ctx.auth.can('EDIT_FEES_PARCELS'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _cache[5] || (_cache[5] = _createElementVNode("label", { for: "frn" }, "Frais de retour *", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  style: {"color":"#f14d12"},
                                  id: "frn",
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formColis.returned_fees) = $event)),
                                  disabled: 
                        _ctx.row.invoiced == 1 ||
                        (_ctx.row.status == 'DELIVERED' &&
                          (_ctx.row.situation == 'Facturé' || _ctx.row.invoiced == 1))
                      
                                }, null, 8, _hoisted_12), [
                                  [_vModelText, _ctx.formColis.returned_fees]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.auth.can('PARCELS') && _ctx.auth.can('EDIT_FEES_PARCELS'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _cache[6] || (_cache[6] = _createElementVNode("label", { for: "frs" }, "Frais de refus *", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  style: {"color":"#f14d12"},
                                  id: "frs",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formColis.refused_fees) = $event)),
                                  disabled: 
                        _ctx.row.invoiced == 1 ||
                        (_ctx.row.status == 'DELIVERED' &&
                          (_ctx.row.situation == 'Facturé' || _ctx.row.invoiced == 1))
                      
                                }, null, 8, _hoisted_15), [
                                  [_vModelText, _ctx.formColis.refused_fees]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("hr")
            ], -1)),
            _createElementVNode("div", _hoisted_16, [
              (_ctx.auth.can('PARCELS'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1 float-right",
                    disabled: _ctx.loading,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.AddColis && _ctx.AddColis(...args)))
                  }, [
                    _cache[7] || (_cache[7] = _createTextVNode(" Enregistrer ", -1)),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_17))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}